import React from "react"
import style from "./video-embed.mod.scss"
import PropTypes from "prop-types"
import { getVideoEmbedUrl } from "@config/videoHelpers"

const VideoEmbed = ({ video, title }) => {
  if (!video) return null

  return (
    <div className={style["video-embed"]}>
      <div className={style["video-embed__wrapper"]}>
        <iframe
          className={style["video-embed__iframe"]}
          src={getVideoEmbedUrl(video)}
          title={title || video.title}
          frameBorder="0"
          referrerPolicy="strict-origin-when-cross-origin"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  )
}

VideoEmbed.propTypes = {
  video: PropTypes.shape({
    url: PropTypes.string,
    provider: PropTypes.string,
    providerUid: PropTypes.string,
    title: PropTypes.string
  }),
  title: PropTypes.string
}

export default VideoEmbed
